import template from 'text!./injury-details.html';

export default {
    template,
    bindings: {
        workersComp: '='
    }
};
